var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5H14.5V14.5H1.5V1.5Z",
    fill: "#F5C276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2V14H2V2H14ZM15 1H1V15H15V1Z",
    fill: "#C29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1V3C5 3.552 5.448 4 6 4H10C10.552 4 11 3.552 11 3V1H5Z",
    fill: "#66798F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1C7 1.26522 7.10536 1.51957 7.29289 1.70711C7.48043 1.89464 7.73478 2 8 2C8.26522 2 8.51957 1.89464 8.70711 1.70711C8.89464 1.51957 9 1.26522 9 1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0V0Z",
    fill: "#66798F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H15.5V15.5H7.5V7.5Z",
    fill: "#F2FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8V15H8V8H15ZM16 7H7V16H16V7Z",
    fill: "#788B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7H14V16H13V7ZM9 7H10V16H9V7Z",
    fill: "#F2FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13V14H7V13H16Z",
    fill: "#F2FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9V10H7V9H16Z",
    fill: "#F2FAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3dd1ef6ca90e6070b4ed6b66ccd01922.svg";
export { ForwardRef as ReactComponent };